// Number/date formatting shared by the analytics dashboard. Kept tiny and
// dependency-free; every value renders in --font-mono with tabular-nums.

export const fmtInt = (v) => (v == null ? '—' : Number(v).toLocaleString());

export const fmtCompact = (v) => {
  if (v == null) return '—';
  const abs = Math.abs(v);
  if (abs >= 1_000_000) return `${(v / 1_000_000).toFixed(1)}M`;
  if (abs >= 10_000) return `${(v / 1_000).toFixed(0)}k`;
  if (abs >= 1_000) return `${(v / 1_000).toFixed(1)}k`;
  return Number(v).toLocaleString();
};

export const fmtUsd = (v) => {
  if (v == null) return '—';
  if (v > 0 && v < 0.01) return '<$0.01';
  return `$${Number(v).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

export const fmtMetric = (v) => {
  if (v == null || Number.isNaN(v)) return '—';
  const abs = Math.abs(v);
  if (abs >= 1000) return fmtCompact(v);
  if (abs >= 10) return v.toFixed(1);
  return v.toFixed(3);
};

export const fmtDuration = (sec) => {
  if (sec == null) return '—';
  if (sec < 60) return `${Math.round(sec)} s`;
  if (sec < 3600) return `${Math.floor(sec / 60)} min ${Math.round(sec % 60)} s`;
  return `${Math.floor(sec / 3600)} h ${Math.round((sec % 3600) / 60)} min`;
};

export const fmtDateTime = (iso) => {
  if (!iso) return '—';
  return new Date(iso).toLocaleString(undefined, {
    year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit',
  });
};

export const fmtDate = (iso) => {
  if (!iso) return '—';
  return new Date(iso).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
};

export const fmtDay = (isoDay) => {
  const d = new Date(`${isoDay}T00:00:00`);
  return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
};

export const relTime = (iso) => {
  if (!iso) return 'never';
  const diff = (Date.now() - new Date(iso).getTime()) / 1000;
  if (diff < 60) return 'just now';
  if (diff < 3600) return `${Math.floor(diff / 60)} min ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)} h ago`;
  if (diff < 86400 * 30) return `${Math.floor(diff / 86400)} d ago`;
  return fmtDate(iso);
};

export const fmtShape = (dataset) => {
  if (!dataset || (dataset.rows == null && dataset.cols == null)) return '—';
  if (dataset.cols == null) return `${fmtInt(dataset.rows)} rows`;
  return `${fmtInt(dataset.rows)} × ${fmtInt(dataset.cols)}`;
};

export const titleCase = (s) => (s ? s.replace(/_/g, ' ').replace(/^\w/, (c) => c.toUpperCase()) : '');
